module.exports = __webpack_public_path__ + "img/22_34.82f6b819.png";